import React, { useState} from 'react';
import './FlowChart.css'
import SpeakerCard from './SpeakerCard';
import SpeakerBubble from './SpeakerBubble';
import { Container, Row, Col } from 'react-bootstrap';
import FullTextCard from './FullTextCard';

function generateClassName(index) {
    return `bubble-${index}`;
  }


function FlowChart({ backgroundImage, side }) {
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [isModalOpen, setIsModalOpen] = useState(false);

    // Function to handle the click event and update the state
    const handleBubbleClick = (index) => {
      setSelectedIndex(index);
      
    };
    const [selectedSpeakerIndex, setSelectedSpeakerIndex] = useState(null);

    const handleCloseModal = () => {
      setSelectedSpeakerIndex(null);
      setIsModalOpen(false);
    };
    // Sample data with image URLs and indexes
    const bubbleLeftData = [
      { imageUrl: 'https://static.igem.wiki/teams/4602/wiki/images/bubbles/cri0.jpg', index: 0, header: 'Learning Planet Institute' },
      { imageUrl: 'https://static.igem.wiki/teams/4602/wiki/images/bubbles/who1.png', index: 1, header: 'International White Papers'  },
      { imageUrl: 'https://static.igem.wiki/teams/4602/wiki/images/bubbles/france2.png', index: 2, header: 'France Sexual Health'  },
      { imageUrl: 'https://static.igem.wiki/teams/4602/wiki/download.png', index: 3 , header: 'EU Sexual Health' },
      { imageUrl: 'https://static.igem.wiki/teams/4602/wiki/laure-bubbles-folder/framework.png', index: 4, header: 'Frameworks for Human Practices'  },
      { imageUrl: 'https://static.igem.wiki/teams/4602/wiki/laure-bubbles-folder/dictionnary.jpg', index: 5, header: 'Key Definitions'  },
      { imageUrl: 'https://static.igem.wiki/teams/4602/wiki/images/bubbles/hlhg.png', index: 6, header: 'Word for Hidden Lives Hidden Gems'  },
      { imageUrl: 'https://static.igem.wiki/teams/4602/wiki/images/bubbles/exposes.png', index: 7, header: 'Exposé.e.s'  },
      { imageUrl: 'https://static.igem.wiki/teams/4602/wiki/images/bubbles/condomman.jpg', index: 8, header: 'Artist: Mbuyi Tickson'  },
      { imageUrl: 'https://static.igem.wiki/teams/4602/wiki/laure-bubbles-folder/facettes-1.png', index: 9, header: 'Festival Facettes'  },
      { imageUrl: 'https://static.igem.wiki/teams/4602/wiki/laure-bubbles-folder/pop-updated-vs.png', index: 10, header: 'Advertisement & Pop Culture' },
      { imageUrl: 'https://static.igem.wiki/teams/4602/wiki/laure-bubbles-folder/blue-man.png', index: 11, header: 'Conversation with patient x'  },
      { imageUrl: 'https://static.igem.wiki/teams/4602/wiki/laure-bubbles-folder/akuma.jpeg', index: 12, header: 'Conversation with Akuma'  },
      { imageUrl: 'https://static.igem.wiki/teams/4602/wiki/laure-bubbles-folder/fabienne.jpg', index: 13 , header: 'Conversation with Fabienne Delay-Sineau' },
      { imageUrl: 'https://static.igem.wiki/teams/4602/wiki/laure-bubbles-folder/claire-versini.jpg', index: 14, header: 'Conversation with Claire Versini'  },
      { imageUrl: 'https://static.igem.wiki/teams/4602/wiki/laure-bubbles-folder/portrait-jb-lusignan-2022.jpg', index: 15, header: 'Conversation with Jean-Baptiste Lusignan'  },
      { imageUrl: 'https://static.igem.wiki/teams/4602/wiki/laure-bubbles-folder/slow-cosmetique.png', index: 16, header: 'Conversation with Slow Cosmetics'  },
      { imageUrl: 'https://static.igem.wiki/teams/4602/wiki/laure-bubbles-folder/laurence-dolbois.jpg', index: 17, header: 'Conversation with Laurence Dolbois'  },
      { imageUrl: 'https://static.igem.wiki/teams/4602/wiki/laure-bubbles-folder/greenwoman.png', index: 18, header: 'Conversation with Audrey Gibert'  },
      { imageUrl: 'https://static.igem.wiki/teams/4602/wiki/laure-bubbles-folder/yellowwoman.png', index: 19, header: 'Conversation with Elena Tricca'  },
      { imageUrl: 'https://static.igem.wiki/teams/4602/wiki/jeen-v2.jpg', index: 20, header: 'Conversation with Tessa Beccaria'  },
      { imageUrl: 'https://static.igem.wiki/teams/4602/wiki/laure-bubbles-folder/lilawoman.png', index: 21, header: 'Conversation with Christine Valentin'  },
      { imageUrl: 'https://static.igem.wiki/teams/4602/wiki/laure-bubbles-folder/yellow-man.png', index: 22, header: 'Conversation with Mehdi Morel'  },
      { imageUrl: 'https://static.igem.wiki/teams/4602/wiki/laure-bubbles-folder/blue-man.png', index: 23, header: 'Conversation with Antony Srar'  },
      { imageUrl: 'https://static.igem.wiki/teams/4602/wiki/laure-bubbles-folder/earthyellow.png', index: 24, header: 'Outreach & Education'  },
    ];

    const bubbleRightData = [
      { imageUrl:'https://static.igem.wiki/teams/4602/wiki/laure-bubbles-folder/pinkbubble.png', index: 25, header: 'Microbicides'  },
      { imageUrl:'https://static.igem.wiki/teams/4602/wiki/laure-bubbles-folder/harvard.png', index: 26, header: 'Havard T.H. Chan School of Public Health Pannel Discussion'  },
      {imageUrl: 'https://static.igem.wiki/teams/4602/wiki/laure-bubbles-folder/ethicscoloured.png', index: 27, header: 'Ethics'  },
      {imageUrl: 'https://static.igem.wiki/teams/4602/wiki/laure-bubbles-folder/yellow-man.png', index: 28, header: 'Conversation with Bertrand Auvert'  },
      {imageUrl: 'https://static.igem.wiki/teams/4602/wiki/baker-lab.png', index: 29, header: 'Support from Baker Lab'  },
      {imageUrl: 'https://static.igem.wiki/teams/4602/wiki/images/bubbles/photo-morganevbomsel-2022-1.jpeg', index: 30, header: 'Conversation with Morgane Bomsel'  },
      {imageUrl: 'https://static.igem.wiki/teams/4602/wiki/laure-bubbles-folder/cnrp.png', index: 31, header: 'Conversation with Jean-Luc Prétet and Quentin Lepiller'  },
      {imageUrl: 'https://static.igem.wiki/teams/4602/wiki/laure-bubbles-folder/gfp.jpg', index: 32, header: 'Conversation with Arnaud Guitterez'  },
      {imageUrl: 'https://static.igem.wiki/teams/4602/wiki/laure-bubbles-folder/pinkman.png', index: 33, header: 'Conversation with J.D. Shon and G.S. Tender'  },
      {imageUrl: 'https://static.igem.wiki/teams/4602/wiki/laure-bubbles-folder/pasteur.jpg', index: 34, header: 'Conversation with the England Lab'  },
    ];
    const handleReadMoreClick = (index) => {
      setSelectedSpeakerIndex(index);
      setIsModalOpen(true);
    };


    if (side === 'left')
    {
  return (
    <div>
    <Container  fluid style={{marginLeft: '0px', paddingLeft: '0px', marginRight: '0px!important'}}>
      <Row  >
        <Col xs={7}  className="col-lg-6 relative">
          <div className='flow-img-wrapper'>
          <img  className='flow-img' src={"https://static.igem.wiki/teams/4602/wiki/images/images/flow.png"} alt="flow" />
          {bubbleLeftData.map((data) => (
            <div className={generateClassName(data.index)}>
              <SpeakerBubble
                key={data.index}
                imageUrl={data.imageUrl}
                index={data.index}
                onClick={handleBubbleClick}
              />
              </div>
            ))}       
            </div>   
          </Col>


          <Col xs={4}  style={{display: 'flex',
                    flexDirection: 'column', /* Stack card content vertically */
                    flexGrow: '1',
                    paddingLeft: '150px',
                    position: 'sticky',
                    bottom: '11rem',
                    alignSelf: 'flex-end',
 
                    }}>
              <SpeakerCard bubbleData={bubbleLeftData} index={selectedIndex} onReadMoreClick={handleReadMoreClick} componentIndex={selectedIndex}/>
          </Col>
        </Row>
    </Container>

              {isModalOpen && selectedSpeakerIndex !== null && (
                    <FullTextCard index={selectedIndex}
                    show={isModalOpen}
                    onHide={() => setIsModalOpen(false)}
                    onClose={handleCloseModal} />
                          )}
    </div>

  );
              }
    return (
                <div>
    <Container  fluid style={{marginLeft: '0px', paddingLeft: '0px', marginRight: '0px!important'}}>
                  <Row >
                                
                  <Col xs={4} style={{display: 'flex',
                                flexDirection: 'column', /* Stack card content vertically */
                                flexGrow: '1',
                                paddingLeft: '0px',
                                paddingRight: '0px',
                                position: 'sticky',
                                bottom: '11rem',
                                alignSelf: 'flex-end',
                                minWidth: "250px"
                                }}>
                          <SpeakerCard bubbleData={bubbleRightData} index={selectedIndex - 25} onReadMoreClick={handleReadMoreClick} componentIndex={selectedIndex}/>
                      </Col>
                    <Col xs={7}  className="col-lg-6 relative">
                      <div className='flow-img-wrapper-from-right'>
                      <img  style={{transform:'scaleX(-1)', marginLeft: '-500px'}} className='flow-img' src={"https://static.igem.wiki/teams/4602/wiki/wiki-general/entrepeneurship/wave-colour-3.png"} alt="flow2" />
                      {bubbleRightData.map((data) => (
                      <div className={generateClassName(data.index)}>
                        <SpeakerBubble
                          key={data.index}
                          imageUrl={data.imageUrl}
                          index={data.index}
                          onClick={handleBubbleClick}
                        />
                        </div>
                      ))}       
                        </div>   
                      </Col>
            

                    </Row>
                </Container>
            
                          {isModalOpen && selectedSpeakerIndex !== null && (
                    <FullTextCard index={selectedIndex}
                    show={isModalOpen}
                    onHide={() => setIsModalOpen(false)}
                    onClose={handleCloseModal} />
                  )}
                </div>
            
              );
          
    
}

export default FlowChart;
